import React from "react";
import { Link } from "react-router-dom";
import { IoHeadsetOutline } from "react-icons/io5";
import { useI18n } from "../contexts/I18n";
import { marketingI18n } from "../content/homeMarketing";
import useScrollAnimate from "../hooks/useScrollAnimate";
import MarketingPageIntro from "./marketing/MarketingPageIntro";
import FaqSection from "./marketing/FaqSection";
import AISupport from "./AISupport";
import "./Home.css";
import "./MarketingPages.css";
import "./Support.css";
import "./FaqPage.css";

export default function Support() {
  const { t, lang } = useI18n();
  const pageT = marketingI18n[lang].pages.support;
  const marketingT = marketingI18n[lang];
  useScrollAnimate([lang]);

  return (
    <div
      className={`marketing-page support-page ${lang === "ar" ? "rtl" : ""}`}
      dir={lang === "ar" ? "rtl" : "ltr"}
    >
      <MarketingPageIntro variant="support" page={pageT} lang={lang} layout="split" />

      <section className="support-channels-section" aria-labelledby="support-channels-heading">
        <div className="container">
          <header className="support-channels-header scroll-animate from-bottom">
            <h2 id="support-channels-heading" className="support-channels-header__title">
              {pageT.channelsLabel}
            </h2>
            <p className="support-channels-header__lead">{pageT.channelsLead}</p>
          </header>

          <div className="support-reach-card scroll-animate from-bottom delay-1">
            <div className="support-reach-card__header">
              <span className="support-reach-card__header-icon" aria-hidden="true">
                <IoHeadsetOutline />
              </span>
              <h3 className="support-reach-card__title">{pageT.tocLabel}</h3>
            </div>
            <div className="support-reach-card__ai">
              <AISupport embedded />
            </div>
          </div>
        </div>
      </section>

      <section
        id="support-faqs"
        className="support-faqs-section"
        aria-labelledby="support-faqs-heading"
      >
        <div className="container">
          <header className="support-channels-header scroll-animate from-bottom">
            <h2 id="support-faqs-heading" className="support-channels-header__title">
              {pageT.faqsLabel}
            </h2>
            <p className="support-channels-header__lead">{pageT.faqsLead}</p>
          </header>
        </div>
        <FaqSection t={marketingT} lang={lang} showContactCard={false} hidePageTitle pageLayout />
      </section>

      <section className="support-cta-section">
        <div className="container support-cta-inner scroll-animate from-bottom delay-2">
          <h2 className="support-cta-title">{pageT.ctaTitle}</h2>
          <p className="support-cta-desc">{pageT.ctaDesc}</p>
          <div className="support-cta-actions">
            <Link to="/contact" className="support-cta-btn support-cta-btn--primary">
              {pageT.ctaSecondary}
            </Link>
            <Link to="/faq" className="support-cta-btn support-cta-btn--secondary">
              {pageT.cta}
            </Link>
          </div>
        </div>
      </section>

      <div className="section-wave section-wave--light" aria-hidden="true" />
    </div>
  );
}
